import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import NumberFormat from 'react-number-format';

// Local Deps
import NFButton from '../../../../components/primitives/NFButton';
import msgs from '../../../../config/messages';
// import Loading from '../../components/Loading';

import { isPhoneNumber } from '../../../../utils/validationUtils';


export default class UserInfo extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,

    onSubmit: PropTypes.func.isRequired,
    name: PropTypes.string,
    onCancel: PropTypes.func.isRequired,
    // orgType: PropTypes.string.isRequired,
    organization: PropTypes.any.isRequired,
    email: PropTypes.string,
    phone: PropTypes.string,
  };

  static defaultProps = {
    name: '',
    phone: '',
    email: '',
  };


  render() {
    const {
      onChange,
      onSubmit,
      name,
      phone,
      email,
      onCancel,
      // orgType,
      organization,
    } = this.props;

    return (
      <div>
        <input id='orgTextName' style={{ 'display': 'none' }} value={this.props.organization.name} />

        <Row style={{ flexWrap: 'nowrap' }}>
          <Col style={{ marginTop: '16px' }}>
            {/* <!-- LOADING --> */}
            {/* <!-- CONTENT --> */}
            <div className="nf-registration__content">
              <Row className="nf-row--justify-end" />
              {/* <!-- USERS GRID --> */}
              <div className="nf-registration__layout">
                <div className="nf-registration__input">
                  <p> Full Name *</p>
                  <input id="name"
                    className="input-registration"

                    type="text"
                    value={name}
                    placeholder="Name"
                    name="name"
                    onChange={onChange}
                  />
                </div>
                <div className="nf-registration__input">
                  <p>{msgs.Registration.user.phone} *</p>
                  {/*                  
                  <input
                    className="input-registration"

                    isRequired
                    type="text"
                    placeholder="Phone Number"
                    value={phone}
                    name="phone"
                    onChange={onChange}
                  />
*/}
                  <NumberFormat isRequired className="input-registration" value={phone} id="phone" name="phone" placeholder="Phone Number" format="(###) ###-####" mask="_" onValueChange={isPhoneNumber} onChange={onChange} />

                </div>

                <div className="nf-registration__input">
                  <p> {msgs.Registration.user.Email} *</p>
                  <input id="email"
                    className="input-registration"
                    value={email}
                    type="email" placeholder="Email Address"
                    onChange={onChange} name="emailAddress" />
                </div>
                {!organization.organizationType && (
                  <div className="nf-registration__input">
                    <p />
                  </div>
                )}
                <div className="nf-registration--wrapper">
                  <div className="nf-registration__buttons">
                    <NFButton
                      className="nf-button--gray-border"
                      style={{ marginRight: '16px' }}
                      onClick={() => {
                        onCancel();
                      }}
                    >
                      {msgs.Form.backButton}
                    </NFButton>
                    <NFButton
                      className="nf-button--form nf-button--orange"
                      type="submit"
                      disabled={!name || !email || !phone}
                      onClick={() => {
                        onSubmit();
                      }}
                    >

                      {msgs.Form.continueButton}
                    </NFButton>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Registration/subComponents/UserInfo/UserInfo.jsx